module.exports = __webpack_public_path__ + "static/media/kuberindustries.03fb4649.png";